<template>
	<div id="accessible-remote-header"></div>
</template>

<script>
export default {
	name: 'Header',
	props: [],
	data: function() {
		return {}
	},
	methods: {},
	computed: {}
};
</script>

<style scoped>
</style>
